import React from 'react';
import {cnSettingsMenu, ISettingsMenuGroupProps} from "../SettingsMenu";
import {KitchenService} from '../../../../3d/services/KitchenService/KitchenService';
import {ISettingGroupKitCodes} from '../../../../interfaces/settingData/ISettingGroupKitCodes';
import {RadioButton} from '../../../components/RadioButton/RadioButton';
import {RADIO_BUTTON_TYPE_KIT_CODE} from '../../../../../common-code/constants';
import {TKitCode} from '../../../../../common-code/types/catalog/TKitCode';

export interface ISettingsMenuKitCodesGroupProps extends ISettingsMenuGroupProps {
    kitCodesData: ISettingGroupKitCodes;
    service: KitchenService;
}

export const SettingsMenuKitCodes: React.FC<ISettingsMenuKitCodesGroupProps> =
    ({className, onRebuildUnitData, kitCodesData}) => {

        const onSelectKitCode = (value: TKitCode) => {
            onRebuildUnitData(
                'setKitCode',
                {kitCode: value}
            );
        }

        return (
            <div className={cnSettingsMenu('KitCodes', [className])}>
                <RadioButton type={RADIO_BUTTON_TYPE_KIT_CODE}
                             options={kitCodesData.kitCodes}
                             value={kitCodesData.kitCode}
                             callBack={(value: string) => {
                                 onSelectKitCode(value as TKitCode);
                             }}/>
            </div>
        );
    }
